import * as actionTypes from "../../Actions/MicroHubs/ActionTypes";
import * as actionReducer from "./ActionReducer";

const initialState = {
  Dialogs: {
    ShowEditHub: false,
    ShowCreateHub: false,
    ShowDeleteHub: false,
  },
  AllHubsTable: {
    error: null,
    request: null,
    response: null,
  },
  AllHubs: {
    error: null,
    request: null,
    response: null,
  },
  CreateHub: {
    error: null,
    request: null,
    response: null,
  },
  EditHub: {
    error: null,
    request: null,
    response: null,
  },
  DeleteHub: {
    error: null,
    request: null,
    response: null,
  },
  SingleHub: {
    error: null,
    request: null,
    response: null,
  },
  AssignPolyToHub: {
    error: null,
    request: null,
    response: null,
  },
  RemoveHubPolygon: {
    error: null,
    request: null,
    response: null,
  },
};

const HubReducer = (state = initialState, action) => {
  switch (action.type) {

    case actionTypes.TOGGLE_DIALOGS:
      return actionReducer.toggleDialogs(state, action);

    case actionTypes.CLEAR_MICROHUB_STATE:
      return actionReducer.clearState(state, action, initialState);

    case actionTypes.GET_ALL_HUBS:
      return actionReducer.getAllHubs(state, action);
    case actionTypes.GET_ALL_HUBS_SUCCESS:
      return actionReducer.getAllHubsSuccess(state, action);
    case actionTypes.GET_ALL_HUBS_FAIL:
      return actionReducer.getAllHubsFail(state, action);

    case actionTypes.CREATE_HUB:
      return actionReducer.createHub(state, action);
    case actionTypes.CREATE_HUB_SUCCESS:
      return actionReducer.createHubSuccess(state, action);
    case actionTypes.CREATE_HUB_FAIL:
      return actionReducer.createHubFail(state, action);

    case actionTypes.EDIT_HUB:
      return actionReducer.editHub(state, action);
    case actionTypes.EDIT_HUB_SUCCESS:
      return actionReducer.editHubSuccess(state, action);
    case actionTypes.EDIT_HUB_FAIL:
      return actionReducer.editHubFail(state, action);

    case actionTypes.DELETE_HUB:
      return actionReducer.deleteHub(state, action);
    case actionTypes.DELETE_HUB_SUCCESS:
      return actionReducer.deleteHubSuccess(state, action);
    case actionTypes.DELETE_HUB_FAIL:
      return actionReducer.deleteHubFail(state, action);

    case actionTypes.GET_HUB_BY_ID:
      return actionReducer.getHubById(state, action);
    case actionTypes.GET_HUB_BY_ID_SUCCESS:
      return actionReducer.getHubByIdSuccess(state, action);
    case actionTypes.GET_HUB_BY_ID_FAIL:
      return actionReducer.getHubByIdFail(state, action);

    case actionTypes.ASSIGN_POLYGON_TO_HUB:
      return actionReducer.assignPolygonToHub(state, action);
    case actionTypes.ASSIGN_POLYGON_TO_HUB_SUCCESS:
      return actionReducer.assignPolygonToHubSuccess(state, action);
    case actionTypes.ASSIGN_POLYGON_TO_HUB_FAIL:
      return actionReducer.assignPolygonToHubFail(state, action);

    case actionTypes.REMOVE_HUB_FROM_POLYGON:
      return actionReducer.removeHubFromPolygon(state, action);
    case actionTypes.REMOVE_HUB_FROM_POLYGON_SUCCESS:
      return actionReducer.removeHubFromPolygonSuccess(state, action);
    case actionTypes.REMOVE_HUB_FROM_POLYGON_FAIL:
      return actionReducer.removeHubFromPolygonFail(state, action);

    default:
      return state;
  }
};

export { HubReducer };